<template>
  <span class="d-flex align-center">
    <span class="white--text caption" data-cy="releaseNote__text--copyUnavailable" v-if="!isEligible">
      <v-icon color="amber" x-small class="mr-1">fas fa-exclamation-triangle</v-icon>
      <span>This template can be copied once it is Published.</span>
    </span>
    <v-btn
      @click.stop="setDialog(true)"
      class="my-1"
      color="white"
      data-cy="releaseNote__button--directCopy"
      outlined
      small
      v-else
    >
      <v-icon x-small class="mr-2">fas fa-copy</v-icon>Copy to New Release Note
    </v-btn>
    <v-dialog v-model="dialog" max-width="700" persistent>
      <release-note-direct-copy-dialog
        v-if="dialog"
        :releaseNote="releaseNote"
        @setDialog="setDialog"
      ></release-note-direct-copy-dialog>
    </v-dialog>
  </span>
</template>

<script>
import ReleaseNoteDirectCopyDialog from "./ReleaseNoteDirectCopyDialog.vue";

export default {
  components: { ReleaseNoteDirectCopyDialog },
  computed: {
    isEligible() {
      return this.releaseNote.documentationStatus === "Published";
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    setDialog(val) {
      this.dialog = val;
    },
  },
  props: {
    releaseNote: { required: true, type: Object },
  },
};
</script>
